<template>
  <div class="box">
    <div class="choice-warp">
        <!-- <div class="choice-left">
            <el-tree
                :data="viewData"
                :props="defaultFrameworkProps"
                @node-click="bindNodeClick"
                style="height:613px"
            ></el-tree>
        </div> -->
        <div class="choice-right">
        <el-table
            :data="viewmeasureTable"
            border
            style="width: 100%"
            @row-click="clicktable"
            height="495"
            :highlight-current-row="true"
        >
            <el-table-column prop="measureName" label="测量点名称" ></el-table-column>
            <el-table-column prop="measureRemark" label="备注" ></el-table-column>
            <el-table-column prop="measureId" label="id"  v-if="false"></el-table-column>
        </el-table>
        </div>
    </div>
  </div>
</template>

<script>
import { creatMenuJson } from "@/utils/index.js";
import * as utils from "@/utils/index.js";
import { isNull } from "util";
import { creatTreeJson } from "@/utils/tree.js";
export default {
  props: {
    viewtab: {
      type: Object,
      default: () => ({
        all: true,
        framework: true,
        view: true,
        class: true
      })
    },
    viewId: {
      type: String,
      default: "1"
    }
  },
  data() {
    return {
      viewData: [],
      defaultFrameworkProps: {
        label: "name",
        children: "children"
      },
      defaultFrameworkClassProps: {
        children: "groups"
      },
      viewmeasureTable: [],
      measureTable: [],
      id:'',
    };
  },
  mounted() {
    this.getViewTreeNodes(this.viewId)
  },
  watch: {},
  methods: {
    //获取视图表格
    getViewTreeNodes(id){
        let vm=this
        vm.$api.view.getViewTreeNodes(id).then(res => {
            if (res) {
                vm.viewmeasureTable = res.data;
            }
        });
    },
    //弹窗点击确定
    clicktable(row) {
        let data = {};
        data.id = row.measureId;
        data.name = row.measureName;
        data.remark = row.measureRemark;
        this.$emit("clicktable", data);
    },
  }
};
</script>

<style scoped lang="scss">
.box {
  margin-top: 5px;
    margin-bottom: 5px;
    width: 100%;
    height: 100%;
  .el-tabs__nav-scroll {
    height: 70%;
  }
}
.choice-warp {
  display: flex;
    height: 500px;
    padding:0 30px;
    box-sizing: border-box;
}
.choice-left {
  flex: 0 0 255px;
  margin-right: 35px;
  border: 1px solid;
  overflow: auto;
}
.choice-right {
  width:100%;
}
</style>